<template>
  <card
    class="card-text"
    :title="title"
    style="
      color: blue;
      font-size: 20px;
      white-space: pre-line;
      text-align: center;
      font-weight: bolder;
    "
  >
    <div>
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12">
          <div class="row">
            <h5>Sistemas Administrativos</h5>
            <div
              class="col-md-3 mb-3"
              v-for="(sis, key) in sistemasperAdm"
              :key="key"
            >
              <div
                class="cardRedirect systemCard"
                @click="openSystemURL(sis.URL)"
              >
                <!-- Bloque superior -->
                <div class="card-top">
                  <div class="card-top-content">
                    <div class="sigla-block">{{ sis.Descripcion }}</div>
                    <div class="castle-block">
                      <img :src="castleImg" alt="" class="castle-img" />
                    </div>
                  </div>
                  <div class="yellow-divider"></div>
                </div>
                <!-- Bloque inferior -->
                <div class="card-bottom">{{ sis.Nombre }}</div>
              </div>
            </div>

            <br />

            <h5 v-if="sistemasperAcad.length > 0">Sistemas Académicos</h5>
            <div
              class="col-md-3 mb-3"
              v-for="(sis, key) in sistemasperAcad"
              :key="key"
            >
              <div
                class="cardRedirect systemCard"
                @click="openSystemURL(sis.URL)"
              >
                <div class="card-top">
                  <div class="card-top-content">
                    <div class="sigla-block">{{ sis.Descripcion }}</div>
                    <div class="castle-block">
                      <img :src="castleImg" alt="" class="castle-img" />
                    </div>
                  </div>
                  <div class="yellow-divider"></div>
                </div>
                <div class="card-bottom">{{ sis.Nombre }}</div>
              </div>
            </div>

            <h5 v-if="sistemasOtros.length > 0">Otros Sistemas</h5>
            <div
              class="col-md-3 mb-3"
              v-for="(sis, key) in sistemasOtros"
              :key="key"
            >
              <div
                class="cardRedirect systemCard"
                @click="openSystemURL(sis.URL)"
              >
                <div class="card-top">
                  <div class="card-top-content">
                    <div class="sigla-block">{{ sis.Descripcion }}</div>
                    <div class="castle-block">
                      <img :src="castleImg" alt="" class="castle-img" />
                    </div>
                  </div>
                  <div class="yellow-divider"></div>
                </div>
                <div class="card-bottom">{{ sis.Nombre }}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="col-xl-5 col-lg-5 col-md-5">
          <ul class="list-unstyled team-members" >
            <li>
              <div class="row mt-1" v-for="(sis, key) in sistemasper"  :key="key" style="border-bottom: 3px solid rgba(128, 128, 128, 0.3);; margin-left: 10px; margin-right: 10px; ">
                 <div class="col-2 justify-content-center d-flex"  >
                  <div >
                    <i class="ti-desktop" style="border-bottom: 2px solid grey;"></i>
                  </div>
                </div> 
                <div class="col-12 justify-content-center aling-items-center float-left">
                  <p style="margin: 0px; text-align: left;" class="text-primary">{{ sis.sistema.Nombre }}  </p>
                  <p  class="text-secondary" style="float: left;"> <b>{{ sis.sistema.Descripcion }} - </b> 
                      <a :href="rutaApp +'storage/documents/' + sis.sistema.Manual" target="_blank" class="text-warning"> <b> Ver manual </b></a>
                    </p>
                  

                  <hr>


                   <span :class="getStatusClass(member.status)">
                    <small>{{ member.status }}</small>
                  </span> 
                </div>



                 <div class="col-3 justify-content-center d-flex">
                  <p-button type="success" outline icon>
                    <i class="fa fa-envelope"></i>
                  </p-button>
                </div> 

                
              </div>

            </li>
          </ul>

        </div> -->
      </div>
    </div>

    <!-- <div>
      <vue-advanced-chat
        height="calc(100vh - 20px)"
        :current-user-id="currentUserId"
        :rooms="JSON.stringify(rooms)"
        :rooms-loaded="true"
        :messages="JSON.stringify(messages)"
        :messages-loaded="messagesLoaded"
        @send-message="sendMessage($event.detail[0])"
        @fetch-messages="fetchMessages($event.detail[0])"
      />
    </div> -->
  </card>
</template>
<script>
import { register } from "vue-advanced-chat";
register();

import MainService from "@/services/MainService.js";

import { EventBus } from "@/plugins/event-bus"; // Importa el bus de eventos

export default {
  metaInfo: {
    // Configura los encabezados de respuesta para evitar la caché
    httpEquiv: {
      "Cache-Control": "no-store",
      Expires: "Thu, 01 Jan 1970 00:00:00 GMT",
      Pragma: "no-cache",
    },
  },

  data() {
    return {
      ss: new MainService(),
      title: "Iniciador de sistemas",
      castleImg: require("@/assets/img/catillou.png"),
      members: [
        {
          image: require("@/assets/img/faces/face-0.jpg"),
          name: "Dj Khaled",
          status: "Offline",
        },
        {
          image: require("@/assets/img/faces/face-1.jpg"),
          name: "Henry ",
          status: "Available",
        },
        {
          image: require("@/assets/img/faces/face-1.jpg"),
          name: "Flume",
          status: "Busy",
        },
      ],

      // chat
      currentUserId: "1234",
      rooms: [
        {
          roomId: "1",
          roomName: "Escuela",
          avatar: "https://66.media.tumblr.com/avatar_c6a8eae4303e_512.pnj",
          users: [
            { _id: "1234", username: "John Doe" },
            { _id: "4321", username: "John Snow" },
          ],
        },
        {
          roomId: "1",
          roomName: "Cariñosas",
          avatar: "https://66.media.tumblr.com/avatar_c6a8eae4303e_512.pnj",
          users: [
            { _id: "1234", username: "John Doe" },
            { _id: "4321", username: "John Snow" },
          ],
        },
      ],
      messages: [],
      messagesLoaded: false,
      auth: {},
      sistemasperAcad: [],
      sistemasperAdm: [],
      sistemasOtros: [],
      cantSistPer: null,
      rutaApp: process.env.VUE_APP_RRHH_SERVICE,
      sistemas: [
        { id: 25, descripcion: "EMINEWS" },
        { id: 24, descripcion: "SISCUP" },
        { id: 29, descripcion: "SIDEC" },
        { id: 26, descripcion: "EXPOEMI" },
        { id: 1, descripcion: "SIACT" },
        { id: 3, descripcion: "SISAS" },
        { id: 22, descripcion: "SISAR" },
        { id: 21, descripcion: "MIS SISTEMAS" },
        { id: 23, descripcion: "SISNIGE" },
        { id: 27, descripcion: "SIPLA" },
        { id: 2, descripcion: "SISAL" },
        { id: 28, descripcion: "IGD.png" },
        { id: 7, descripcion: "RDP.png" },
        { id: 8, descripcion: "SISCER" },
        { id: 15, descripcion: "RPP.png" },
        { id: 9, descripcion: "RTG.png" },
        { id: 16, descripcion: "RGGP.png" },
        { id: 18, descripcion: "RGRA.png" },
        { id: 13, descripcion: "RKE.png" },
        { id: 4, descripcion: "RUB.png" },
        { id: 17, descripcion: "RGP.png" },
        { id: 19, descripcion: "RPOS.png" },
        { id: 14, descripcion: "POA.png" },
        { id: 5, descripcion: "CORIN.png" },
        { id: 12, descripcion: "IGA-G.png" },
        { id: 32, descripcion: "RDC.png" },
        { id: 6, descripcion: "RDG.png" },
        { id: 30, descripcion: "SUGEMI" },
        { id: 11, descripcion: "SIRESI" },
        { id: 31, descripcion: "CIBEREMI" },
        { id: 10, descripcion: "RIPRE.png" },
        { id: 34, descripcion: "RIE.png" },
        { id: 33, descripcion: "SISIR" },
        { id: 37, descripcion: "RNE.png" },
        { id: 38, descripcion: "SAGA" },
        { id: 39, descripcion: "RNG.png" },
        { id: 40, descripcion: "RNPOS.png" },
        { id: 42, descripcion: "JDC-GRADO" },
        { id: 36, descripcion: "POA.png" },
        { id: 20, descripcion: "RPDEA.png" }, //fala
        { id: 41, descripcion: "CERCC.png" },
        { id: 35, descripcion: "CERIN.png" },
        { id: 43, descripcion: "RGA.png" },
        { id: 44, descripcion: "RCI.png" },
        { id: 45, descripcion: "RNPRE.png" },
        { id: 46, descripcion: "RNI.png" },
        { id: 47, descripcion: "IGA-P.png" },
        { id: 48, descripcion: "RAL.png" },
        { id: 49, descripcion: "IGA-G.png" },
        { id: 50, descripcion: "POA.png" },
      ],
      // fin chat
    };
  },
  methods: {
    openSystemURL(url) {
      const email = this.auth.email;
      //window.open(url+"?email="+email, '_blank');
      const newTab = window.open(url + "?email=" + email, "_blank");

      // Emitir el evento para decir que se ha abierto una nueva pestaña
      if (newTab) {
        EventBus.$emit("newTabOpened", newTab);
      }
    },

    getStatusClass(status) {
      switch (status) {
        case "Offline":
          return "text-muted";
        case "Available":
          return "text-success";
        case "Busy":
          return "text-danger";
        default:
          return "text-success";
      }
    },

    getLogo(sistemaId) {
      const sistema = this.sistemas.find((sis) => sis.id === sistemaId);
      // console.log(sistema);
      if (!sistema) {
        return require(`@/assets/img/RGA.png`); // imagen por defecto si el id no existe
      }
      const imagePath =
        sistema.descripcion && sistema.descripcion.endsWith(".png")
          ? sistema.descripcion
          : "RGA.png";
      return require(`@/assets/img/${imagePath}`);
    },
    // chat

    fetchMessages({ options = {} }) {
      setTimeout(() => {
        if (options.reset) {
          this.messages = this.addMessages(true);
        } else {
          this.messages = [...this.addMessages(), ...this.messages];
          this.messagesLoaded = true;
        }
        // this.addNewMessage()
      });
    },

    addMessages(reset) {
      const messages = [];

      for (let i = 0; i < 30; i++) {
        messages.push({
          _id: reset ? i : this.messages.length + i,
          content: `${reset ? "" : "paginated"} message ${i + 1}`,
          senderId: "4321",
          username: "John Doe",
          date: "13 November",
          timestamp: "10:20",
        });
      }

      return messages;
    },

    sendMessage(message) {
      this.messages = [
        ...this.messages,
        {
          _id: this.messages.length,
          content: message.content,
          senderId: this.currentUserId,
          timestamp: new Date().toString().substring(16, 21),
          date: new Date().toDateString(),
        },
      ];
    },

    addNewMessage() {
      setTimeout(() => {
        this.messages = [
          ...this.messages,
          {
            _id: this.messages.length,
            content: "NEW MESSAGE",
            senderId: "1234",
            timestamp: new Date().toString().substring(16, 21),
            date: new Date().toDateString(),
          },
        ];
      }, 2000);
    },

    getSistemasPersona() {
      this.ss
        .listSistemasPersona(this.auth.email)
        .then((result) => {
          let response = result.data;
          this.sistemasperAcad = response.data;
          this.sistemasperAdm = response.data2;
          this.sistemasOtros = response.data3;

          // Obtener la cantidad de elementos en sistemasper
          this.cantSistPer =
            this.sistemasperAcad.length +
            this.sistemasperAdm.length +
            this.sistemasOtros.length;
          //console.log("Resultados Listado Persona");
          //console.log(this.cantSistPer);
          //console.log(this.sistemasper);
          this.title = `Usted tiene asignado: ${this.cantSistPer} sistemas`;
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
    },
  },
  mounted() {
    this.auth = JSON.parse(localStorage.getItem("usuario"));
    // console.log(this.auth);
    if (!this.auth) {
      // this.$router.push('/Login');
    } else {
      this.getSistemasPersona();
      // this.print();
    }
  },
};
</script>


<style lang="scss">
body {
  font-family: "Quicksand", sans-serif;
}

.cardRedirect {
  transition: box-shadow 0.3s ease, transform 0.3s ease;
  cursor: pointer;
}

.cardRedirect:hover {
  box-shadow: 0 0 15px 5px rgba(#003f8a, 0.7);
  transform: translateY(-4px);
}

.systemCard {
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);

  .card-top {
    padding: 12px 18px 0;

    .card-top-content {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;

      .sigla-block {
        font-family: "Montserrat", sans-serif;
        color: #003f8a;
        font-weight: 900;
        font-size: 1.85rem;
        letter-spacing: 2px;
        text-transform: uppercase;
        line-height: 1;
        flex: 0 0 auto;
      }

      .castle-block {
        flex-shrink: 0;

        .castle-img {
          width: 63px;
          height: 63px;
          object-fit: contain;
          margin-bottom: 0;
        }
      }
    }

    .yellow-divider {
      width: 40%;
      height: 6px;
      background: #e8a820;
      border-radius: 3px;
      margin: 4px auto 0;
    }
  }

  .card-bottom {
    padding: 10px 12px 14px;
    text-align: center;
    color: #003f8a;
    font-weight: 700;
    font-size: 12px;
    line-height: 1.4;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
}
</style>
